import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, first, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EventService } from './event.service';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  // public languages: string[] = ['en', 'es', 'de', 'it', 'pt', 'fr'];
  public languages: string[] = ['en', 'de', 'pt', 'fr'];
  currentLangSubject!: BehaviorSubject<string>;

  constructor(
    public translate: TranslateService,
    private cookieService: CookieService,
    private http: HttpClient,
    private eventService: EventService
  ) {

    let browserLang: any;
    /***
     * cookie Language Get
    */
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    }
    else {
      browserLang = translate.getBrowserLang();
    }
    this.currentLangSubject = new BehaviorSubject<string>(browserLang);
    this.setLanguage(browserLang.match(/en|de|pt|fr/) ? browserLang : 'en', true);
  }

  init() {
    // this function is only for init the service when app init
    return;
  }

  /***
   * Cookie Language set
   */
  public setLanguage(lang: any, first: boolean = false) {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
    this.currentLangSubject.next(lang);
    if (!first)
      this.eventService.broadcast('language-change', lang);
  }

  public getLanguages() {
    return this.http.get<any>(`${environment.apiUrl}/languages`, { withCredentials: true }).pipe(first());
  }

  getCurrentLang() {
    return this.currentLangSubject.value;
  }
}
